import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  evalCondition,
  getLang,
  storeGet
} from 'mailup-react-helpers'
import transformations from '../../../../components/PreviewTool/transformations'

import { beMessGetMessageDetails } from 'Api/BeMessApi'
import { statisticsApiGetMessageTotalCounters } from 'Api/StatisticsApi'
import { beAccountsApiGetAccountCustomSettings } from 'Api/beAccountsApi'
import { beEmailMessageApiListDynamicContentByIdMessage } from 'Api/beEmailMessageApi'
import { beEmailRenderingApiGeneratePreview } from 'Api/beEmailRenderingApi'
import { beSendGoApiExistSendingRunningMessage } from 'Api/beSendGoApi'
import {
  collaborationApiGetAccountProjects,
  collaborationApiGetLoginData
} from 'Api/collaborationApi'

import {
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import {
  bePersonalizationApiGetListActivation,
  bePersonalizationApiGetMessageActivation
} from 'Api/bePersonalizationApi'
import {
  CHANNEL_TYPE_EMAIL,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  GROUPS_SEARCH_TYPE_EQUALTO,
  SUBSCRIPTION_TYPE_SUBSCRIBED,
  beRecipientGetListOfGroupDetails,
  beRecipientSearchForRecipients
} from 'Api/beRecipientApi'
import {
  COLLABORATION_PROJECT_STATUS_APPROVED,
  COLLABORATION_PROJECT_STATUS_ARCHIVED,
  COLLABORATION_PROJECT_STATUS_OPEN,
  STORE_KEY_USER_LISTS
} from 'Constants/'
import { LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED } from 'Constants/index'

import { beListGetMandatorySender } from 'Api/BeListApi'
import {
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings
} from 'Api/beAccountSettingsApi'
import getIntl from 'Helpers/intl'
import { isOfferLight } from 'Helpers/options'

export async function getMessageDetails(idMessage) {
  const messageDetails = await beMessGetMessageDetails(idMessage)
  const userLists = storeGet(STORE_KEY_USER_LISTS)

  if (messageDetails === null || !userLists.includes(messageDetails.IdList)) {
    throw new Error('Check message permissions failed')
  }

  return messageDetails
}

export async function generatePreview(idMessage, params) {
  const res = await beEmailRenderingApiGeneratePreview(idMessage, params)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)

  const transformedContent = transformations(res.Content)
    .replaceHref({
      '#': ['http://', `http://${Domain}`, `http://${Domain}/`]
    })
    .disablePointerEvents('a[href^="["]')
    .disablePointerEvents('a[href="#"]')
    .disablePointerEvents('a[href=""]')
    .secureBlankTargets()
    .getHtml()

  return {
    ...res,
    Content: transformedContent
  }
}

export async function getMessageDynamicContents(idMessage) {
  const results = await beEmailMessageApiListDynamicContentByIdMessage(
    idMessage
  )

  return results.map(({ Id, Name }) => ({ id: Id, name: Name }))
}

export async function getAvailableActions(idMessage, idList, IsBee) {
  const idCurrentList = storeGet(STORE_KEY_ID_LIST)
  const result = await statisticsApiGetMessageTotalCounters(
    idList,
    idMessage,
    'EI'
  )
  const hasStats = result.Counters.TotalCounters.EI > 0

  const actions = {
    overview: evalCondition('NOT uo:NONL'),
    edit:
      (IsBee &&
        evalCondition(
          'NOT uo:NONL AND uo:BEEEDITORENABLE AND co:BEEEDITORENABLE'
        )) ||
      (!IsBee && evalCondition('NOT uo:NONL')),

    checkup: evalCondition('uo:CHECKUP'),
    quickSend: idCurrentList === idList && evalCondition('NOT uo:NOSEND'),
    collaborationUpselling:
      evalCondition(
        'NOT co:COLLABORATIONS OR (uo:GEST AND NOT uo:COLLABORATIONS )'
      ) && !isOfferLight(),
    collaboration: evalCondition('uo:COLLABORATIONS') && !isOfferLight(),
    statistics: hasStats && evalCondition('uo:STAT')
  }

  return actions
}

export async function isSendingMessage(idMessage) {
  const result = await beSendGoApiExistSendingRunningMessage(idMessage)

  return result
}

export async function getCollaborationProjectUrl(idMessage, subject) {
  const result = await collaborationApiGetAccountProjects(
    [
      COLLABORATION_PROJECT_STATUS_OPEN,
      COLLABORATION_PROJECT_STATUS_APPROVED,
      COLLABORATION_PROJECT_STATUS_ARCHIVED
    ],
    [`NL_${idMessage}`]
  )

  const idProject =
    result && Array.isArray(result.Items) && result.Items.length > 0
      ? result.Items[0].IdProject
      : undefined

  const account = storeGet(STORE_KEY_ACCOUNT)
  const lang = getLang()

  const IsWhiteLabel = evalCondition('co:WHITELABEL')

  const projectUrl = `https://${
    account.Domain
  }/frontend/nl_preview_window.aspx?idNL=${idMessage}&fc=${btoa(
    `${idMessage}`
  )}&hideAtt=1`

  const { AppName, LogoutUrl } = await beAccountsApiGetAccountCustomSettings()

  const customizations = IsWhiteLabel
    ? {
        customizations: [
          {
            Key: 'companylogourl',
            Value: `https://${account.Domain}/img/ApplicationLogo.jpg`
          },
          { Key: 'companyname', Value: AppName },
          { Key: 'companyurl', Value: LogoutUrl }
        ]
      }
    : {}

  const data = idProject
    ? {
        IdProject: idProject,
        navigation: 'True',
        hideresolvedthreads: 'False',
        ...customizations
      }
    : {
        projectReference: `NL_${idMessage}`,
        htmlUrl: projectUrl,
        projectName: subject,
        ...customizations
      }

  const loginData = await collaborationApiGetLoginData(data)

  const loginUrl = `https://${process.env.COLLABORATION_FRONTEND_URL}/login?token=${loginData.Data.Token}&lang=${lang}`

  return loginUrl
}

export async function searchRecipients(search, dynamicFields) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { pageNumber, pageSize, orderDescending } = search

  const searchParams = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize,
    pageNumber,
    orderDescending,
    excludeFields: false
  }

  const searchConditions = getSearchConditions(search)

  const apiParams = new Map()
  apiParams.set('idList', idList)
  apiParams.set('searchParams', searchParams)
  apiParams.set('searchConditions', searchConditions)

  const res = await beRecipientSearchForRecipients(...apiParams.values())

  return {
    ...res,
    Items: res.Items.map(item => {
      const fields = new Map().set('Email', item.Email)

      const fieldsEntries = item.Fields.filter(({ Id }) =>
        dynamicFields.find(df => df.Id === Id)
      ).map(dynamicField => [dynamicField.Id, dynamicField.Value])

      const allFields = fieldsEntries.reduce((acc, [fieldId, fieldValue]) => {
        const dynamicField = dynamicFields.find(
          dynamicField => fieldId === dynamicField.Id
        )
        return acc.set(dynamicField.Description, fieldValue)
      }, fields)

      return {
        id: item.Id,
        fields: allFields,
        fieldsEntries
      }
    })
  }
}

const getSearchConditions = search => {
  const {
    channel,
    email,
    includeGroups,
    applyFilters,
    applyFiltersOr,
    optOutTypeEmail,
    optOutTypeSms,
    optOutMessage
  } = search

  return {
    IncludeGroups: [...includeGroups],
    MatchingFilters: applyFilters.length
      ? {
          Condition: applyFiltersOr,
          Filters: [...applyFilters]
        }
      : undefined,
    UnsubscriptionType:
      channel === 'email' ? `${optOutTypeEmail}` : `${optOutTypeSms}`,
    UnsubscriptionMessage: channel === 'email' ? optOutMessage : undefined,
    Email: email,
    EmailMatchType: 'CONTAINS'
  }
}

export function updatePreviewReferenceRecipient(dataValue) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beAccountSettingsUpsertUserSettings(
    idList,
    'previewReferenceRecipient',
    dataValue
  )
  return result || {}
}

export async function getListActivation() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION'
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetListActivation(idList)
    : { Items: [] }

  return result
}
export async function getMessageActivation(idMessage) {
  const hasPersonalization = evalCondition(
    'co:PERSONALIZATION OR co:ADVPERSONALIZATION'
  )

  const result = hasPersonalization
    ? await bePersonalizationApiGetMessageActivation(idMessage)
    : { Items: [] }

  return result
}

export async function getGroups(searchBy, exact = false) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchBy,
    searchType: exact
      ? GROUPS_SEARCH_TYPE_EQUALTO
      : GROUPS_SEARCH_TYPE_ECONTAINS
  })
  return Items.map(({ Id, Name, Notes }) => ({
    label: `${Id} - ${Name}${Notes ? ' (' + Notes + ')' : ''}`,
    value: Id
  }))
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const filters = await beFiltersGetListOfFilters(idList, {
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false,
    hidden
  })

  const allFilters = filters.Items
  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function getPreviewReferenceRecipient(idList) {
  const result = await beAccountSettingsGetUserSetting(
    idList,
    'previewReferenceRecipient'
  )

  if (result && result.DataValue) {
    return JSON.parse(result.DataValue)
  }

  return {}
}

export async function getMandatorySenderAction() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beListGetMandatorySender(idList)
  return result
}
